module.exports = __webpack_public_path__ + "img/number-chart.d375e6b6.png";